import { createNavigator } from "single-spa/react-app/router/utils/BaseNavigator";

import { ROUTES } from "./searchAdvertisingConstants";
import type { SearchAdvertisingParamKeys } from "./searchAdvertisingRoutes.types";

export const searchAdvertisingNavigation = createNavigator<SearchAdvertisingParamKeys, typeof ROUTES>(ROUTES);
